import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventResponse, SponsorResponse, EventSponsorResponse } from '../../../../../../../../@shared/models/response.module';
import { EventsService } from '../../../../../../../../@shared/services/events-service';
import { AddSponsor } from '../../../manage-event/components/manage-event-sponsor/components/add-sponsor/add-sponsor';
import { EditSponsor } from '../../../manage-event/components/manage-event-sponsor/components/edit-sponsor/edit-sponsor';
import { _AQH_EVE_16, _AQH_EVE_21 } from '../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-wizard-step-sponsors',
  standalone: false,
  templateUrl: './wizard-step-sponsors.html',
  styleUrl: './wizard-step-sponsors.css'
})
export class WizardStepSponsors {
  @Input() event: EventResponse | null = null;
  @Output() eventUpdated = new EventEmitter<EventResponse>();

  sponsors: SponsorResponse[] = [];
  eventSponsors: EventSponsorResponse[] = [];
  private lastLoadedEventId: number | null = null;

  constructor(
    private modalService: NgbModal,
    private eventService: EventsService
  ) {}

  ngOnInit() {
    this.loadSponsors();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['event'] && this.event?.event_id && this.event.event_id !== this.lastLoadedEventId) {
      this.loadSponsors();
    }
  }

  loadSponsors() {
    if (!this.event?.event_id) return;

    this.lastLoadedEventId = this.event.event_id;
    const payload: _AQH_EVE_21 = { event_id: this.event.event_id };
    this.eventService.getEventSponsors(payload).subscribe({
      next: (res: EventSponsorResponse[]) => {
        this.eventSponsors = res;
        this.sponsors = res
          .map((es: EventSponsorResponse) => es.sponsor)
          .filter((s): s is SponsorResponse => s !== null && s !== undefined);
      }
    });
  }

  openAddSponsorModal() {
    if (!this.event) return;

    const modalRef = this.modalService.open(AddSponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.event = this.event;

    modalRef.result.then((result: SponsorResponse) => {
      if (result && result.sponsor_id) {
        // Add the newly created sponsor to this event
        const addToEventPayload: _AQH_EVE_16 = {
          event_id: this.event!.event_id,
          sponsor_id: result.sponsor_id
        };
        this.eventService.addSponsorToEvent(addToEventPayload).subscribe(() => {
          this.loadSponsors();
        });
      }
    }).catch(() => {});
  }

  openEditSponsorModal(sponsor: SponsorResponse) {
    if (!this.event) return;

    const modalRef = this.modalService.open(EditSponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.sponsor = sponsor;

    modalRef.result.then((result) => {
      if (result) {
        this.loadSponsors();
      }
    }).catch(() => {});
  }

  deleteSponsor(sponsor: SponsorResponse) {
    if (!confirm(`Are you sure you want to remove "${sponsor.sponsor_name}" from the event?`)) return;

    // Find the entry_id for this sponsor
    const eventSponsor = this.eventSponsors.find(es => es.sponsor_id === sponsor.sponsor_id);
    if (eventSponsor) {
      this.eventService.removeSponsorFromEvent({
        entry_id: eventSponsor.entry_id
      }).subscribe({
        next: () => {
          this.loadSponsors();
        }
      });
    }
  }
}
